module.exports = __webpack_public_path__ + "static/media/EditIcon.698f838c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/EditProfile/EditIcon.svg
// module id = 346
// module chunks = 0